import React from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FormLabel from '@material-ui/core/FormLabel'
import TextField from '@material-ui/core/TextField'
import SchoolInformation from '../../../components/SchoolInformation'
import Intolerance from '../../../components/Intolerance'
import Diet from '../../../components/Diet'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField8: {
    width: '62.666667%',
    marginLeft: 0,
    marginRight: 0,
  },
}))

export default function StepInformation(props) {
  const classes = useStyles()
  const {onChange, step3NoteLeaving} = props
  // const errors = props.errors || {}

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Informazioni utili</Typography>
        </Grid>

        <Grid item xs={12}>
          <Intolerance />
        </Grid>

        <Grid item xs={12}>
          <Diet />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">
            Scuola italiana e livello linguistico
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SchoolInformation />
        </Grid>

        <Grid item xs={12}>
          <div className="box-light">
            <FormLabel component="legend">
              Eventuali comunicazioni relative al soggiorno
            </FormLabel>
            <TextField
              id="multiline-flexible"
              multiline
              rowsMax="4"
              value={step3NoteLeaving}
              className={classes.textField8}
              margin="normal"
              onChange={onChange('step3NoteLeaving')}
            />
          </div>
        </Grid>
      </Grid>
    </form>
  )
}

StepInformation.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  step3NoteLeaving: PropTypes.string,
}
